import _ from 'underscore';

export default function scrollHack(plugin: any) {
	const grid = plugin;
	let currentDeltaProp: any;

	// Every 32 ms of scroll silence will give a direction a chance to become the main delta
	const resetCurrentDeltaTimeout = _.debounce(() => {
		currentDeltaProp = null;
	}, 32);

	// Slow down will ya?
	const scroll = _.throttle((scrollBar: any, delta: number) => {
		scrollBar.index += delta;
	}, 16);

	const fixScrollBar = (scrollBar: any) => {
		// Mousewheel triggered
		const scrolled = (bar: any, evt: any) => {
			const deltaProp = scrollBar.deltaProp;
			const delta = evt[deltaProp];

			// Store our max scroll extents
			if (deltaProp === 'deltaX') {
				grid._maxScrollX = scrollBar._max;
			} else {
				grid._maxScrollY = scrollBar._max;
			}

			// Can we be the main delta?
			// Having an event for a delta of 0/-0 is odd imo
			if ((!currentDeltaProp && delta > 1) || delta < -1) {
				currentDeltaProp = deltaProp;
			}

			// If we are the main delta then we get to scroll
			if (currentDeltaProp === deltaProp) {
				// Turn it down a lot - anything over 20x less starts to be negatively noticeable
				scroll(scrollBar, delta / 20);
				(delta >= 1 || delta <= -1) && resetCurrentDeltaTimeout();
			}

			evt.stopPropagation();
			evt.preventDefault();
		};

		// See finbars
		if (scrollBar.deltaProp !== null) {
			const container = scrollBar.container || scrollBar.bar.parentElement;
			container.removeEventListener('wheel', scrollBar._bound.onwheel);
			container.addEventListener('wheel', (evt: any) => {
				scrolled(scrollBar, evt);
			});
			scrollBar._bound.onwheel = (evt: any) => {
				evt.stopPropagation();
				evt.preventDefault();
			};
		} else {
			scrollBar._bound.onwheel = (evt: any) => {
				scrolled(scrollBar, evt);
			};
		}
	};

	fixScrollBar(grid.sbHScroller);
	fixScrollBar(grid.sbVScroller);
}
